module.exports = __webpack_public_path__ + "d04b0f6ef39c6a1649124f5ceb64e8b9.png";